import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { Container, Alert, Button, Heading, Stack, Text, FormControl, Input, Textarea, EmptyCard, Box } from '@/components/lib'
import api from '../../api'
import utils from '@/utils/utils'
import useStore from '../../store'
import useTitle from '../../hooks/useTitle'

export default function NewTrial () {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { search } = useLocation()
  const { user, updateUser, team, updateTrial } = useStore()
  useTitle('New Trial')

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search)
      const name = params.get('name')
      if (name) setName(name)
    }
  }, [search])

  function createTrial () {
    setError()
    setLoading(true)
    api.teams.createTrial(user.team, { name, description }, trial => {
      updateTrial(trial._id, trial) // Ensure trial added to the store
      api.users.me(u => updateUser(u._id, u)) // Refresh user to get new trial permissions
      api.users.createEmailSubscription(user._id, `trial.${trial._id}.participantMessages`, ({ subscriptions }) => updateUser(user._id, { subscriptions }))
      navigate(`/trials/${trial._id}/manage`)
      setLoading(false)
      utils.toast('success', 'Trial created successfully')
    }, err => {
      setError(err.message)
      setLoading(false)
    })
  }

  return (
    <Container>
      <Stack direction={{ base: 'column', md: 'row' }} gap={10}>
        <Box>
          <EmptyCard icon='research' title='Trials' description='A trial (or "project") is a space for defining your study and collecting data. Once created you can add other staff to help manage or collect your data, define your variables, setup your forms, and manage participants.' />
        </Box>
        <Stack flex={1} gap={5} p={5} bg='bg.surface' rounded='md' borderWidth='1px' borderColor='border.default'>
          <Heading as='h2' size='lg'>Create a new trial</Heading>
          <Text>This trial will be managed by the {team && team.name} team.</Text>

          <FormControl label='Trial name'>
            <Input autoFocus value={name} onChange={e => setName(e.target.value)} placeholder='Intervention or trial name' />
          </FormControl>

          <FormControl label='Trial description'>
            <Textarea value={description} onChange={e => setDescription(e.target.value)} placeholder='This trial aims to...' />
          </FormControl>
          <Alert variant='left-accent' status='info'>Please note that this information can be changed at any time.</Alert>

          {error &&
            <Alert variant='left-accent' status='error'>There was a problem creating your trial: {error}</Alert>}

          <Stack direction='row' justifyContent='end' alignItems='center'>
            <Button variant='ghost' onClick={() => navigate('/trials')}>Cancel</Button>
            <Button isLoading={loading} colorPalette='primary' onClick={createTrial}>Create trial</Button>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  )
}
